import { usePage } from '@wbk/contentful/api';
import { useParams } from 'react-router-dom';
import FullpageAnimatedLogo from '@/components/ui/Loading/FullpageAnimatedLogo';
import Seo from '@/components/headers/seo';
import Error404 from '@/components/error/404';

import ZonesSections from '@/components/web-sections/ZonesSections';

const Zones = () => {
  const { lang } = useParams<{ lang: Language }>();
  const {
    data: home,
    isLoading,
    error,
  } = usePage({ lang, limit: 1, where: { slug: 'riyadh-season-zones' } });

  if (isLoading) {
    return <FullpageAnimatedLogo />;
  }

  if (!home || error) {
    return <Error404 />;
  }

  return (
    <>
      <Seo
        title={home.seo?.title || home.title}
        description={home.seo?.description}
        image={home.seo?.image?.url}
      />

      <div className='relative h-full w-full'>
        <div className='col-span-12 space-y-24'>
          {home?.sectionsCollection.items.map((section, idx) =>
            section.__typename === 'WebSection' ? (
              <ZonesSections key={section.__typename + idx} section={section} />
            ) : null
          )}
        </div>
      </div>
    </>
  );
};

export default Zones;
